<span [dir]="options.dir!">
  <mat-sidenav-container class="mainWrapper" autosize autoFocus
    [ngClass]="{ 'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' && !resView,
                 'sidebarNav-horizontal': options.horizontal,
                  cardBorder: options.cardBorder,
                  orange_theme: options.activeTheme == 'orange_theme',
                  blue_theme: options.activeTheme == 'blue_theme',
                  aqua_theme: options.activeTheme == 'aqua_theme',
                  purple_theme: options.activeTheme == 'purple_theme',
                  green_theme: options.activeTheme == 'green_theme',
                  cyan_theme: options.activeTheme == 'cyan_theme'}">
    <!-- ============================================================== -->
    <!-- Horizontal Sidebar -->
    <!-- ============================================================== -->
    <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'"
    [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver && !resView"
        (openedChange)="onSidenavOpenedChange($event)" class="sidebarNav">
        <div class="flex-layout">
          <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
          <ng-scrollbar class="position-relative" style="height: 100%">
            <mat-nav-list class="sidebar-list">
              @for(item of navItems; track item.route) {
              <app-nav-item [item]="item" (notify)="sidenav.toggle()">
              </app-nav-item>
              }
            </mat-nav-list>
          </ng-scrollbar>
        </div>
      </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Main Content -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="contentWrapper" #content>
      <!-- horizontal header -->
       <div class="position-fixed">
        <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()" (toggleMobileNav)="sidenav.toggle()"></app-header>
      </div>
      <main class="pageWrapper" [ngClass]="{ maxWidth: options.boxed }">
        <router-outlet></router-outlet>
      </main>
      <footer class="footer-copyright">{{ footer }}</footer>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- ------------------------------------------------------------------
    Mobile Apps Sidebar
    ------------------------------------------------------------------ -->
  <mat-drawer #filterNavRight mode="over" position="end" class="filter-sidebar">
    <div class="d-flex justify-content-between align-items-center">
      <div class="branding">
        <a href="/">
          <img src="./assets/images/logos/dark-logo-svg.svg" class="align-middle m-2" alt="logo" />
        </a>
      </div>
      <button mat-icon-button (click)="filterNavRight.toggle()" class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
      </button>
    </div>
  </mat-drawer>
</span>
